import React from 'react';
import CheckCircleIcon from '@heroicons/react/solid/CheckCircleIcon.js';
import ExclamationCircleIcon from '@heroicons/react/solid/ExclamationCircleIcon.js';
import RefreshIcon from '@heroicons/react/solid/RefreshIcon.js';
import { SupportedIconNames } from './types.js';
export const SolidIcon = ({ name }) => {
    switch (name) {
        case SupportedIconNames.RefreshIcon:
            return React.createElement(RefreshIcon, null);
        case SupportedIconNames.CheckCircleIcon:
            return React.createElement(CheckCircleIcon, null);
        case SupportedIconNames.ExclamationCircleIcon:
            return React.createElement(ExclamationCircleIcon, null);
        case SupportedIconNames.ArrowsRightLeftIcon:
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" })));
        default: {
            const exhaustiveCheck = name;
            return exhaustiveCheck;
        }
    }
};
//# sourceMappingURL=SolidIcon.js.map